import React from 'react';
import { css } from 'registration-flow-v2';
import PreprodEnvBanner from './PreprodEnvBanner';
import PreprodIllustration from './PreprodIllustration';
import * as styles from './preprod-sign-in.css';

interface IProps {
  children?: React.ReactNode;
}

const PreprodSignInLayout = ({ children }: IProps): JSX.Element => (
  <div className={css(styles.pageRoot)()}>
    <PreprodEnvBanner />

    <div className={css(styles.content)()}>
      <div className={css(styles.illustrationSide)()}>
        <div className={css(styles.illustrationSvgWrap)()}>
          <PreprodIllustration />
        </div>
        <div className={css(styles.wordmarkWrap)()}>
          <div className={css(styles.wordmark)()}>GoodHuman</div>
          <div className={css(styles.envLabel)()}>
            <span className={css(styles.envLabelDot)()} />
            Pre-Production
          </div>
        </div>
      </div>

      <div className={css(styles.card)()}>{children}</div>
    </div>

    <div className={css(styles.footerLinks)()}>
      <a href='https://goodhuman.me/terms-of-use/' target='_blank' rel='noreferrer'>
        Terms
      </a>
      <a href='https://goodhuman.me/sitemap/' target='_blank' rel='noreferrer'>
        Sitemap
      </a>
      <a href='https://goodhuman.me/privacy/' target='_blank' rel='noreferrer'>
        Privacy
      </a>
      <a href='https://www.goodhuman.me/' target='_blank' rel='noreferrer'>
        GoodHuman ©
      </a>
    </div>
  </div>
);

export default PreprodSignInLayout;
